import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { SectionsInfo } from "../GQLCalls/getLfStructureCall";


export type LfSectionItem = DynamicDataObk<SectionsInfo[]>

const lfSectionsDataAdapter = createEntityAdapter({
  selectId: (item: LfSectionItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<LfSectionItem, string>, {con, data}: LfSectionItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "section_id")
    data.forEach((entry) => dataDictionary[entry.section_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      lfSectionsDataAdapter.upsertOne(state, newPayload);
    }
  } else { lfSectionsDataAdapter.addOne(state, {con, data})}
}

const lfSectionsSlice = createSlice({
  name: "lfSections",
    initialState: lfSectionsDataAdapter.getInitialState<LfSectionItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<LfSectionItem>) => {
          mergePayloadAndState(state, payload);
        }
    }
})

export const LfSectionActions = lfSectionsSlice.actions;
export default lfSectionsSlice.reducer;